// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* mapbox-styles.css */

/* Contenedor del popup */
.mapboxgl-popup-content {
  background: rgba(255,255,255,0.97) !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12) !important;
  padding: 0 !important;
  min-width: 220px;
  font-family: 'DM Sans', system-ui, sans-serif;
  overflow: hidden;
}

/* Quitar flecha por defecto */
.mapboxgl-popup-tip {
  display: none !important;
}

/* Header del popup - Adaptado de nw-popup-header */
.nw-popup-header {
  background: #0f2d5e;
  color: #fff;
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Body del popup */
.nw-popup-body {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nw-popup-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11px;
}

.nw-popup-label {
  color: #64748b;
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: .06em;
  font-weight: 500;
}

.nw-popup-value {
  font-weight: 600;
  color: #0f172a;
  font-family: 'DM Mono', monospace;
  font-size: 11px;
}

/* Status badge dentro del popup */
.nw-popup-status {
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}
.nw-popup-status.up  { background:#d1fae5; color:#057a55 }
.nw-popup-status.dwn { background:#fce7f3; color:#db2777 }
.nw-popup-status.odd { background:#fee2e2; color:#e02424 }
.nw-popup-status.exc { background:#fef3c7; color:#d97706 }
.nw-popup-status.unk { background:#f1f5f9; color:#64748b }

/* Estilos para tablas dentro de popups (si existen) */
.custom-popup table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 5px;
  font-size: 10px;
}

.custom-popup th {
  background: #f8fafc;
  color: #64748b;
  font-weight: 600;
  text-align: left;
  padding: 4px 8px;
  border-bottom: 1px solid #e2e8f0;
}

.custom-popup td {
  padding: 4px 8px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
}

/* Custom Marker Styles */
.nw-marker {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.nw-marker:hover {
  transform: scale(1.3);
  z-index: 1000 !important;
}

/* Pulsing effect for Alert states */
@keyframes marker-pulse {
  0% { box-shadow: 0 0 0 0px var(--ring-color); }
  100% { box-shadow: 0 0 0 10px rgba(0,0,0,0); }
}

.nw-marker--alert {
  animation: marker-pulse 2s infinite;
}
`, "",{"version":3,"sources":["webpack://./src/components/monitor-components/devicesMap/mapbox-styles.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB,yBAAyB;AACzB;EACE,6CAA6C;EAC7C,oCAAoC;EACpC,6BAA6B;EAC7B,kDAAkD;EAClD,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,wBAAwB;AAC1B;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA,uBAAuB,kBAAkB,EAAE,cAAc;AACzD,uBAAuB,kBAAkB,EAAE,cAAc;AACzD,uBAAuB,kBAAkB,EAAE,cAAc;AACzD,uBAAuB,kBAAkB,EAAE,cAAc;AACzD,uBAAuB,kBAAkB,EAAE,cAAc;;AAEzD,sDAAsD;AACtD;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,KAAK,uCAAuC,EAAE;EAC9C,OAAO,oCAAoC,EAAE;AAC/C;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["/* mapbox-styles.css */\n\n/* Contenedor del popup */\n.mapboxgl-popup-content {\n  background: rgba(255,255,255,0.97) !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 8px !important;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.12) !important;\n  padding: 0 !important;\n  min-width: 220px;\n  font-family: 'DM Sans', system-ui, sans-serif;\n  overflow: hidden;\n}\n\n/* Quitar flecha por defecto */\n.mapboxgl-popup-tip {\n  display: none !important;\n}\n\n/* Header del popup - Adaptado de nw-popup-header */\n.nw-popup-header {\n  background: #0f2d5e;\n  color: #fff;\n  padding: 10px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* Body del popup */\n.nw-popup-body {\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.nw-popup-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 11px;\n}\n\n.nw-popup-label {\n  color: #64748b;\n  font-size: 9px;\n  text-transform: uppercase;\n  letter-spacing: .06em;\n  font-weight: 500;\n}\n\n.nw-popup-value {\n  font-weight: 600;\n  color: #0f172a;\n  font-family: 'DM Mono', monospace;\n  font-size: 11px;\n}\n\n/* Status badge dentro del popup */\n.nw-popup-status {\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.nw-popup-status.up  { background:#d1fae5; color:#057a55 }\n.nw-popup-status.dwn { background:#fce7f3; color:#db2777 }\n.nw-popup-status.odd { background:#fee2e2; color:#e02424 }\n.nw-popup-status.exc { background:#fef3c7; color:#d97706 }\n.nw-popup-status.unk { background:#f1f5f9; color:#64748b }\n\n/* Estilos para tablas dentro de popups (si existen) */\n.custom-popup table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 5px;\n  font-size: 10px;\n}\n\n.custom-popup th {\n  background: #f8fafc;\n  color: #64748b;\n  font-weight: 600;\n  text-align: left;\n  padding: 4px 8px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.custom-popup td {\n  padding: 4px 8px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #334155;\n}\n\n/* Custom Marker Styles */\n.nw-marker {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.nw-marker:hover {\n  transform: scale(1.3);\n  z-index: 1000 !important;\n}\n\n/* Pulsing effect for Alert states */\n@keyframes marker-pulse {\n  0% { box-shadow: 0 0 0 0px var(--ring-color); }\n  100% { box-shadow: 0 0 0 10px rgba(0,0,0,0); }\n}\n\n.nw-marker--alert {\n  animation: marker-pulse 2s infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
